import EnglishPage from "@/pages/video";
import I18nProvider from "@/components/I18nProvider";

// Russian route for /video. Reuses the English page component untouched — Layout
// walks its JSX tree and swaps text via the translation memory, so the copy
// lives in exactly one place.
export default function RussianPage() {
  return (
    <I18nProvider locale="ru">
      <EnglishPage />
    </I18nProvider>
  );
}
